export default "__VITE_ASSET__dGGyQvP0__"